module.exports = __webpack_public_path__ + "media/introduction/Cert_Icon-47166060.svg";